<template>
  <div class="row mt-4" v-if="campanas.length">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0 panel-section-title">Conversión por campaña</h6>
              <p class="text-xs opacity-7 mb-0">Suscriptores que acabaron realizando al menos una compra</p>
            </div>
            <!-- Ordenar -->
            <div class="btn-group btn-group-sm" role="group">
              <button
                v-for="o in ordenOpciones"
                :key="o.key"
                class="btn btn-sm mb-0"
                :class="orden === o.key ? 'btn-periodo-activo' : 'btn-periodo'"
                @click="orden = o.key"
              >{{ o.label }}</button>
            </div>
          </div>

          <!-- KPIs globales -->
          <div class="row g-2 mb-4">
            <div class="col-6 col-md-3">
              <div class="conv-kpi">
                <div class="conv-kpi__k">Campañas con datos</div>
                <div class="conv-kpi__v">{{ campanas.length }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="conv-kpi">
                <div class="conv-kpi__k">Total suscriptores</div>
                <div class="conv-kpi__v">{{ totalSusc }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="conv-kpi">
                <div class="conv-kpi__k">Total compradores</div>
                <div class="conv-kpi__v conv-kpi__v--azul">{{ totalComp }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="conv-kpi">
                <div class="conv-kpi__k">Conversión media</div>
                <div class="conv-kpi__v" :class="colorConv(convMedia)">{{ convMedia }}%</div>
              </div>
            </div>
          </div>

          <!-- Tabla -->
          <div class="table-responsive">
            <table class="table table-sm conv-table">
              <thead>
                <tr>
                  <th>Campaña</th>
                  <th>Canal</th>
                  <th class="text-center">Suscriptores <span class="th-sub">(canal + pendientes)</span></th>
                  <th class="text-center">Activos en canal</th>
                  <th class="text-center">Compradores</th>
                  <th style="min-width:140px">Conversión</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in convPageRows" :key="c.campana_id">
                  <td class="conv-nombre">{{ c.campana_nombre }}</td>
                  <td class="conv-canal text-xs">{{ c.canal_nombre }}</td>
                  <td class="text-center fw-bold">
                    {{ c.suscriptores }}
                    <span v-if="c.solicitudes_pendientes > 0" class="conv-pend" :title="`${c.entradas} en canal + ${c.solicitudes_pendientes} pendientes`">
                      +{{ c.solicitudes_pendientes }} pend.
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="conv-activos">{{ c.activos }}</span>
                  </td>
                  <td class="text-center">
                    <span class="conv-comp-badge" :class="c.compradores > 0 ? 'conv-comp-badge--yes' : ''">
                      {{ c.compradores }}
                    </span>
                  </td>
                  <td>
                    <div class="conv-bar-row">
                      <div class="conv-bar-track">
                        <div
                          class="conv-bar-fill"
                          :class="colorConvBar(c.tasa_conversion)"
                          :style="{ width: c.tasa_conversion + '%' }"
                        ></div>
                      </div>
                      <span class="conv-pct" :class="colorConv(c.tasa_conversion)">
                        {{ c.tasa_conversion }}%
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginación -->
          <div v-if="convTotalPages > 1" class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
            <p class="text-xs opacity-7 mb-0">{{ convFrom }}-{{ convTo }} de {{ campanasSorted.length }}</p>
            <div class="btn-group">
              <button class="btn btn-sm btn-pagi mb-0" :disabled="convPage <= 1" @click="convPage = 1">«</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="convPage <= 1" @click="convPage--">‹</button>
              <button class="btn btn-sm btn-pagi mb-0" disabled>{{ convPage }} / {{ convTotalPages }}</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="convPage >= convTotalPages" @click="convPage++">›</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="convPage >= convTotalPages" @click="convPage = convTotalPages">»</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTipsterConversionCampana",
  props: {
    campanas: { type: Array, default: () => [] },
  },
  data() {
    return {
      orden: "conv",
      ordenOpciones: [
        { key: "conv",  label: "Conversión" },
        { key: "susc",  label: "Suscriptores" },
        { key: "comp",  label: "Compradores" },
      ],
      convPage: 1,
      convPerPage: 10,
    };
  },
  watch: {
    orden() { this.convPage = 1; },
    campanas() { this.convPage = 1; },
  },
  computed: {
    campanasSorted() {
      const arr = [...this.campanas];
      if (this.orden === "conv")  return arr.sort((a, b) => b.tasa_conversion - a.tasa_conversion);
      if (this.orden === "susc")  return arr.sort((a, b) => b.suscriptores - a.suscriptores);
      if (this.orden === "comp")  return arr.sort((a, b) => b.compradores - a.compradores);
      return arr;
    },
    convTotalPages() { return Math.max(1, Math.ceil(this.campanasSorted.length / this.convPerPage)); },
    convPageRows() {
      const start = (this.convPage - 1) * this.convPerPage;
      return this.campanasSorted.slice(start, start + this.convPerPage);
    },
    convFrom() { return this.campanasSorted.length === 0 ? 0 : (this.convPage - 1) * this.convPerPage + 1; },
    convTo()   { return Math.min(this.convPage * this.convPerPage, this.campanasSorted.length); },
    totalSusc() { return this.campanas.reduce((s, c) => s + c.suscriptores, 0); },
    totalComp() { return this.campanas.reduce((s, c) => s + c.compradores, 0); },
    convMedia() {
      return this.totalSusc > 0 ? ((this.totalComp / this.totalSusc) * 100).toFixed(1) : "0.0";
    },
  },
  methods: {
    colorConv(pct) {
      const p = parseFloat(pct);
      if (p >= 50) return "text-success fw-bold";
      if (p >= 20) return "text-warning fw-bold";
      if (p > 0)   return "text-danger fw-bold";
      return "text-muted";
    },
    colorConvBar(pct) {
      if (pct >= 50) return "conv-bar-fill--verde";
      if (pct >= 20) return "conv-bar-fill--naranja";
      if (pct > 0)   return "conv-bar-fill--rojo";
      return "conv-bar-fill--gris";
    },
  },
};
</script>

<style scoped>
.th-sub { font-size: 0.68rem; font-weight: 400; opacity: .65; white-space: nowrap; }

/* Botones orden */
.btn-periodo {
  background: var(--q-card); color: var(--q-muted);
  border: 1px solid var(--q-border); border-radius: 8px !important;
  font-size: 11px; font-weight: 600; padding: 4px 10px; transition: .15s;
}
.btn-periodo:hover { background: var(--q-hover); color: var(--q-gold); }
.btn-periodo-activo {
  background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover));
  color: var(--q-gold-on) !important; border:1px solid transparent !important;
  border-radius:8px !important; font-size:11px; font-weight:700; padding:4px 10px;
}

/* KPIs */
.conv-kpi {
  background: var(--q-card-alt); border: 1px solid var(--q-border);
  border-radius: 12px; padding: 12px 14px; min-height: 72px;
  display: flex; flex-direction: column; justify-content: center; gap: 3px;
}
.conv-kpi__k { font-size: 11px; color: var(--q-muted); font-weight: 600; text-transform: uppercase; letter-spacing: .4px; }
.conv-kpi__v { font-size: 20px; font-weight: 800; color: var(--q-text); }
.conv-kpi__v--azul { color: var(--q-gold); }

/* Tabla */
.conv-table { font-size: 12px; border-collapse: collapse; }
.conv-table th,
.conv-table td { border: none !important; box-shadow: none !important; }
.conv-table thead th {
  font-size: 10px; text-transform: uppercase; color: var(--q-muted);
  font-weight: 600; border-bottom: 1px solid var(--q-border) !important; padding: 4px 8px;
}
.conv-table tbody td { padding: 8px 8px; border-bottom: 1px solid var(--q-border) !important; vertical-align: middle; }

.conv-nombre { font-weight: 700; color: var(--q-text); max-width: 180px; }
.conv-canal  { color: var(--q-muted); }
.conv-activos { color: var(--q-green); font-weight: 600; }
.conv-pend { display: block; font-size: 10px; font-weight: 500; color: var(--q-amber); opacity: .85; }

.conv-comp-badge {
  display: inline-block; padding: 2px 8px; border-radius: 20px;
  font-size: 11px; font-weight: 700; background: var(--q-hover); color: var(--q-muted);
}
.conv-comp-badge--yes { background: var(--q-green-soft); color: var(--q-green); }

/* Barra de conversión */
.conv-bar-row { display: flex; align-items: center; gap: 8px; }
.conv-bar-track {
  flex: 1; height: 8px; background: var(--q-hover);
  border-radius: 6px; overflow: hidden;
}
.conv-bar-fill {
  height: 100%; border-radius: 6px; transition: width .4s ease;
}
.conv-bar-fill--verde   { background: linear-gradient(90deg,#43a047,#66bb6a); }
.conv-bar-fill--naranja { background: linear-gradient(90deg,#fb8c00,#ffa726); }
.conv-bar-fill--rojo    { background: linear-gradient(90deg,#e53935,#ef9a9a); }
.conv-bar-fill--gris    { background: var(--q-border); }
.conv-pct { font-size: 11px; font-weight: 700; min-width: 36px; text-align: right; }

.btn-pagi {
  background: var(--q-card-alt); border: 1px solid var(--q-border-md);
  color: var(--q-muted); padding: 4px 10px; font-size: 0.8rem; transition: .15s;
}
.btn-pagi:hover:not(:disabled) { background: var(--q-hover); color: var(--q-gold); border-color: var(--q-gold); }
.btn-pagi:disabled { opacity: .4; cursor: not-allowed; }
</style>
